<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	import {
		makeNumbersPrimaryAndBold,
		getErrorOrInfoMessageForMinAndMax,
	} from '../../../../helpers/utilities';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
	//Design system components
	import { Input, Text, Button } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	import type { Device } from '../../../../types/Device';
	export let device: Device;

	const id = real_id(device.id),
		settings = readDeviceSettings(id),
		min = 0,
		max = 80,
		save = async () => {
			waitForResponse = true;
			const res: SettingRequest = await postReq(`/device/generic_command`, {
				id,
				command: `sleep_time`,
				payload: JSON.stringify({ value: Number(value) }),
			});
			const toastTexts = {
				success: $format('sleep_time_scc_toast', {
					values: { value },
					default: `Sleep time set to ${value} minutes.`,
				}),
				danger: $format('sleep_time_err_toast', {
					default: 'Failed to set Sleep time.',
				}),
			};
			onSettingsResponse(res, device, toastTexts);
			waitForResponse = false;
		};

	let value = settings.sleep_time,
		waitForResponse = false;

	$: inputData = getErrorOrInfoMessageForMinAndMax(value, min, max);
</script>

<Text styleType="body-small" class="mb-s">
	{@html makeNumbersPrimaryAndBold(
		`${$format('sleep_time_description', {
			values: { value },
			default: `Pause motion detection for ${value} seconds. (max ${max})`,
		})}`,
	)}
</Text>

<Input
	icon="fas fa-clock"
	class="mb-s"
	bind:value
	info={inputData.info}
	error={inputData.error}
	type="number"
	step={1}
	id="input-my2qsvc"
	aria-label={$format('sleep_time_description', {
		default: `Pause motion detection.`,
	})}
/>

<Button size="m" width="full" loading={waitForResponse} disabled={!!inputData.error} on:click={save}>
	{$format('button_save', { default: 'Save' })}
</Button>
